import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["languageSelector", "languageWarning"];

  connect() {
    this.languageSelected();
  }

  languageSelected() {
    const selectedOption = this.languageSelectorTarget.selectedOptions[0];

    const isMachineTranslated =
      selectedOption.dataset.machineTranslated === "true";

    this.languageWarningTarget.hidden = !isMachineTranslated;
  }
}
